import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/** Same circular overlay control used to page library books. */
export const horizontalEdgeScrollBtnBaseClass =
  'absolute top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border shadow-sm backdrop-blur-sm transition pointer-events-auto';

export const horizontalEdgeScrollBtnClass =
  'border-sky-200/55 bg-white/60 text-sky-700 hover:bg-sky-50/90 dark:border-sky-600/40 dark:bg-slate-900/50 dark:text-sky-200 dark:hover:bg-slate-800/70';

export type HorizontalEdgeScrollButtonsProps = {
  showStart: boolean;
  showEnd: boolean;
  onTowardStart: () => void;
  onTowardEnd: () => void;
  isRtl: boolean;
  startAriaLabel: string;
  endAriaLabel: string;
  /** Extra classes on each button (e.g. `md:hidden`). */
  className?: string;
  colorClass?: string;
};

export const HorizontalEdgeScrollButtons: React.FC<HorizontalEdgeScrollButtonsProps> = ({
  showStart,
  showEnd,
  onTowardStart,
  onTowardEnd,
  isRtl,
  startAriaLabel,
  endAriaLabel,
  className = '',
  colorClass = horizontalEdgeScrollBtnClass,
}) => {
  const btnClass = `${horizontalEdgeScrollBtnBaseClass} ${colorClass} ${className}`.trim();

  return (
    <>
      {showStart && (
        <button
          type="button"
          onClick={onTowardStart}
          className={`${btnClass} ${isRtl ? 'right-0' : 'left-0'}`}
          aria-label={startAriaLabel}
        >
          {isRtl ? (
            <ChevronRight className="h-5 w-5 drop-shadow-sm" aria-hidden />
          ) : (
            <ChevronLeft className="h-5 w-5 drop-shadow-sm" aria-hidden />
          )}
        </button>
      )}
      {showEnd && (
        <button
          type="button"
          onClick={onTowardEnd}
          className={`${btnClass} ${isRtl ? 'left-0' : 'right-0'}`}
          aria-label={endAriaLabel}
        >
          {isRtl ? (
            <ChevronLeft className="h-5 w-5 drop-shadow-sm" aria-hidden />
          ) : (
            <ChevronRight className="h-5 w-5 drop-shadow-sm" aria-hidden />
          )}
        </button>
      )}
    </>
  );
};
